/** Fixed, public campaign destinations. Keep separate from organic resources. */
export const PAID_LANDING_ROUTES = [
  {
    id: "boat-wiring-planner",
    path: "/boat-wiring-planner/",
    title: "Boat wiring planner — edit a real diagram | Crimp",
    description: "Plan your boat’s wiring with a live 12V example. Size wires and fuses, estimate battery runtime and check voltage drop in Crimp. Start free.",
  },
  {
    id: "boat-wiring-software",
    path: "/boat-wiring-software/",
    title: "Boat wiring software — draw, size and export | Crimp",
    description: "Plan your boat’s DC wiring in your browser. Draw circuits, size wires and review fuse choices for free. Crimp Lifetime adds exports and unlimited equipment.",
  },
] as const;

export type PaidLandingRoute = (typeof PAID_LANDING_ROUTES)[number];

export function matchPaidLandingRoute(pathname: string): PaidLandingRoute | null {
  const path = pathname.endsWith("/") ? pathname : `${pathname}/`;
  return PAID_LANDING_ROUTES.find((route) => route.path === path) ?? null;
}
